<template>
  <!-- eslint-disable max-len -->
  <el-dialog
    :title="(item.ID ? '编辑' : '新增') + '产品'"
    :visible="visible"
    @close="onClose"
    @open="onOpen"
    width="30%"
    :close-on-click-modal="false"
  >
    <el-form :model="item" ref="itemform" label-width="85px" :rules="rules">
      <el-form-item label="产品名称" prop="Name">
        <el-input v-model.trim="item.Name" placeholder="请输入产品名称"></el-input>
      </el-form-item>
      <el-form-item label="业务类型" prop="BusinessTypeID">
        <select2
          style="width: 100%"
          v-model="item.BusinessTypeID"
          url="basic?type=BusinessType"
          labelName="Name"
          :clearable="false"
          :currentList="currentBusinessType"
          placeholder="请选择业务类型"
          noDataText="无类型"
          :emptyValue="0"
        ></select2>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="onClose">
        <i class="fas fa-times"></i> 取 消
      </el-button>
      <el-button type="primary" @click="onSubmit" :disabled="submitting || !item.Name">
        <i class="far fa-save"></i> 确 定
      </el-button>
    </div>
  </el-dialog>
</template>

<script>

export default {
  props: {
    value: Object,
    visible: Boolean,
  },
  data() {
    return {
      item: _.clone(this.value),
      rules: {
        Name: [
          { required: true, message: '名称不能为空', trigger: 'blur' },
          { max: 100, message: '名称不能超过100个字', trigger: 'blur' },
        ],
        BusinessTypeID: [
          { required: true, message: '分类不能为空', trigger: 'blur' },
        ],
      },
      submitting: false,
      currentBusinessType: [],
    };
  },
  computed: {
    token() {
      return this.$store.state.auth.token;
    },
  },
  methods: {
    onOpen() {
      if (this.value.ID) {
        this.currentBusinessType = [{ ID: this.value.BusinessTypeID, Name: this.value.BusinessType.Name }];
      }
      this.item = _.cloneDeep(this.value);
    },
    onClose() {
      this.$emit('update:visible', false);
      this.$emit('cancel');
      this.$refs.itemform.resetFields();
    },
    onSubmit() {
      this.$refs.itemform.validate((valid) => {
        if (!valid) {
          return;
        }
        this.submitting = true;
        this.$emit('input', this.item);
        const itemData = { ...this.item };
        // 保存的操作
        this.$axios.request({
          url: this.item.ID ? `software/${itemData.ID}` : 'software',
          method: itemData.ID ? 'put' : 'post',
          data: itemData,
        }).then(() => {
          this.$message.success(itemData.ID ? '编辑成功' : '新增成功');
          this.submitting = false;
          this.$emit(itemData.ID ? 'form:updated' : 'form:created', true);
          this.$emit('form:saved', true);
          this.$emit('update:visible', false);
        }).catch(({ response }) => {
          this.$sys.alarmResponse(response);
          this.submitting = false;
          this.$emit(itemData.ID ? 'form:updated' : 'form:created', false);
          this.$emit('form:saved', false);
        });
      });
    },
  },
};
</script>
